export default "__VITE_ASSET__DzvCC2NB__"